import z from 'zod';
export const containsAleoAddressRegex = /aleo1[a-z0-9]{58}/gi;
export const aleoAddressRegex = /^aleo1[a-z0-9]{58}$/i;
export const aleoViewKeyRegex = /^AViewKey1[a-z0-9]{44}$/i;
export const aleoPrivateKeyRegex = /^APrivateKey1[a-z0-9]{47}$/i;
export const aleoTransitionIdRegex = /^au1[a-z0-9]{58}$/i;
export const aleoTransactionIdRegex = /^at1[a-z0-9]{58}$/i;
export const aleoFieldRegex = /^\d+field$/;
export const aleoU32 = /^\d+u32$/;
export const aleoU64 = /^\d+u64$/;
export const zodAddress = z.string().regex(aleoAddressRegex);
export const zodViewKey = z.string().regex(aleoViewKeyRegex);
export const zodPrivateKey = z.string().regex(aleoPrivateKeyRegex);
export const zodTransitionId = z.string().regex(aleoTransitionIdRegex);
export const zodTransactionId = z.string().regex(aleoTransactionIdRegex);
export const zodField = z.string().regex(aleoFieldRegex);
export const zodU32 = z.string().regex(aleoU32);
export const zodU64 = z.string().regex(aleoU64);
export var InputOutputType;
(function (InputOutputType) {
  InputOutputType['Record'] = 'record';
  InputOutputType['OutputRecord'] = 'outputRecord';
  InputOutputType['Public'] = 'public';
  InputOutputType['Private'] = 'private';
  InputOutputType['Constant'] = 'constant';
  InputOutputType['Future'] = 'future';
  InputOutputType['ExternalRecord'] = 'external_record';
})(InputOutputType || (InputOutputType = {}));
//# sourceMappingURL=aleo.js.map
